import { ProjectReceiptResponse } from '@/types/service-response'

export class ProjectReceipt {
  public constructor (
    readonly komEin: string,
    readonly versandartBezeichnung: string,
    readonly nummer: string,
    readonly datum: string,
    readonly schrittBezeichnung: string,
    readonly mitarbeiterVollerName: string,
    readonly ma: string
  ) {}

  static createFromResponse (responseData: ProjectReceiptResponse[]): Array<ProjectReceipt> {
    let result: Array<ProjectReceipt> = []
    if (responseData) {
      result = responseData.map((item: ProjectReceiptResponse ) => {
        return new ProjectReceipt(
          item.KomEin ? item.KomEin : '',
          item.VersandartBezeichnung ? item.VersandartBezeichnung : '',
          item.Nummer ? item.Nummer : '',
          item.Datum ? item.Datum : '',
          item.SchrittBezeichnung ? item.SchrittBezeichnung : '',
          item.MitarbeiterVollerName ? item.MitarbeiterVollerName : '',
          item.MA ? item.MA : '',
        )
      })
    }
    return result
  }
}
